import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserCompany } from '../models/company.class';

@Injectable({
  providedIn: 'root'
})
export class CompanyProperty {

  private _companyApps: BehaviorSubject<UserCompany> = new BehaviorSubject<any>(null);
  public companyApps: Observable<UserCompany> = this._companyApps.asObservable();

  constructor() { }

  public setCompanyApps(companyApps: any): void {
    this._companyApps.next(companyApps);
  }
  public get userCompanyApps(): any {
    return this._companyApps.getValue();
  }
}
